
export type ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType = typeof ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType[keyof typeof ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageListResponsePageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
